<template>
  <div id="orderlist" style="width: 100%; height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
        style="padding-top: 0; margin-top: 0" size="medium" label-suffix="：">
        <el-form-item label="副仓" v-if="subWarehouseList && subWarehouseList.length > 1 && 是团餐客户列表">
          <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable multiple collapse-tags
            style="width: 200px;">
            <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户" v-if="是供应商客户列表">
          <el-select v-model="searchForm.SUPPLIER" filterable placeholder="请选择客户" clearable style="width: 200px;">
            <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户" v-if="是团餐客户列表">
          <el-select filterable v-model="searchForm.TC_COMPANY" placeholder="请选择客户" :clearable="true"
            @change="queryPROJECT">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点" v-if="是团餐客户列表">
          <el-select filterable v-model="searchForm.PROJECT" placeholder="请选择项目点" @change="querydkList" clearable
            multiple collapse-tags>
            <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              <span style="float: left">{{ item.PROJECT_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口" v-if="是团餐客户列表">
          <el-select filterable v-model="searchForm.dkName" placeholder="请选择档口" clearable>
            <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="searchForm.PRODUCT_NAME" placeholder="请输入产品名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单ID">
          <el-input v-model="searchForm.ORDER_ID" placeholder="请输入订单ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="送货日期">
          <el-date-picker v-model="searchForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择送货日期"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" v-if="是团餐客户列表">
          <el-select filterable v-model="searchForm.STATUS" placeholder="请选择状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送类型" v-if="是团餐客户列表">
          <el-select multiple filterable v-model="searchForm.DETAIL_TYPE" placeholder="请选择配送类型" clearable>
            <el-option v-for="item in 团餐客户配送类型列表" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单备注" v-if="是团餐客户列表">
          <el-input v-model="searchForm.ORDER_LIST_COMMENT" placeholder="请输入订单备注" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button id="search" type="primary" @click="handleSearch" :loading="initLoad">筛选</el-button>
        </el-form-item>
        <el-col>
          <el-form-item>
            <el-button v-if="是团餐客户列表" type="primary" plain @click="团餐导出订单()" v-show="fun_dic[1000208]">导出订单</el-button>
            <el-button v-if="是供应商客户列表" type="primary" plain @click="供应商导出订单()" v-show="fun_dic[1000208]">
              导出订单
            </el-button>
            <el-button type="primary" plain @click="exportAllInfoOrder" v-show="fun_dic[1000217]">全部信息导出订单</el-button>
            <el-button v-if="是团餐客户列表" @click="exportEnterOrder(0)" v-show="fun_dic[1000205]">
              导入订单（LKD编码）
            </el-button>
            <el-button v-if="是团餐客户列表" @click="exportEnterOrder(1)" v-show="fun_dic[1000206]">
              导入订单（客户编码）
            </el-button>
            <el-button v-if="是团餐客户列表" @click="exportPriceOrder(0)" v-show="fun_dic[1000202]">
              带价格导入订单（LKD编码）
            </el-button>
            <el-button v-if="是团餐客户列表" @click="exportPriceOrder(1)" v-show="fun_dic[1000203]">
              带价格导入订单（客户编码）
            </el-button>
            <el-button v-if="是团餐客户列表" type="primary" plain @click="openExportPDF" v-show="fun_dic[1000209]">
              导出PDF
            </el-button>
            <el-button v-if="是团餐客户列表" @click="exportPriceOrderNoGoods" v-show="fun_dic[1000204]">
              带价格导入订单（LKD编码 不合并商品）
            </el-button>
            <el-button v-if="是团餐客户列表" @click="conversionConfirmed">一键转换确认订单</el-button>
            <el-button v-if="是团餐客户列表" @click="transferShop">一键转换采购</el-button>
            <el-button type="primary" plain @click="exportMergeOrder" v-show="是团餐客户列表 && fun_dic[1000210]">
              导出合并PDF订单
            </el-button>
            <tooltip-button type="primary" v-if="是供应商客户列表 && fun_dic[1000212]" :disabled="Boolean(供应商客户一键转待确认列表[0])"
              tipContent="请选择订单" buttonText="一键转换确认订单" @click="supplierConversionConfirmed">
            </tooltip-button>
            <el-button @click="importGHOrder" v-show="fun_dic[1000214]">导入订单（高后订单）</el-button>
            <el-button @click="批量删除()" v-show="是团餐客户列表 && fun_dic[1000215]">批量删除</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-dialog title="选择日期" center :visible.sync="exportTatolDialog" width="600px">
      <el-form :model="exportForm" ref="exportForm" label-width="auto">
        <el-form-item label="起始日期">
          <el-date-picker v-model="exportForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitExportDate">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24">
        <el-tabs type="border-card" @tab-click="handleTabClick" v-model="客户类型">
          <el-tab-pane label="团餐客户订单" name="团餐客户订单">
            <el-table :data="newOrderListData" border stripe show-summary :summary-method="getSummaries"
              style="width: 100%" @selection-change="(val) => 团餐客户订单勾选(val)">
              <el-table-column type="selection" width="60"></el-table-column>
              <el-table-column label="订单ID" width="80" prop="ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
              <el-table-column prop="TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="COUNT" label="单品数量" min-width="100"></el-table-column>
              <el-table-column prop="SUPPLEMENT" label="是否补单" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_LIST_COMMENT" label="订单备注" min-width="100"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="100"></el-table-column>
              <el-table-column prop="CATALOG_NAME" label="分类" min-width="100"></el-table-column>
              <el-table-column label="状态" min-width="100">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.SUPPLIER_STATUS == 1">已转</el-tag>
                  <el-tag v-else>未转</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="270">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
                  <el-button type="text" size="small" @click="delData(scope.row)" v-if="fun_dic[1000207]">
                    删除
                  </el-button>
                  <el-button type="text" size="small" @click="openDateDia(scope.row)"
                    v-show="(Number(scope.row.TC_STATUS) == 2 || Number(scope.row.TC_STATUS) == 3) && fun_dic[1000201]">
                    修改日期
                  </el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">
                    导出
                  </el-button>
                  <el-button v-show="scope.row.ADDED_ORDER > 0 && fun_dic[1000211]" type="text" size="small"
                    @click="setAddedOrderFlag(scope.row, 0)">
                    不是补单
                  </el-button>
                  <el-button v-if="scope.row.ADDED_ORDER === 0 && fun_dic[1000211]" type="text" size="small"
                    @click="setAddedOrderFlag(scope.row, 2)">
                    是补单
                  </el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">
                    订单资质
                  </el-button>
                  <el-button type="text" size="small" @click="oneButton(scope.row)">打印</el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告</el-button>
                  <el-button type="text" size="small" @click="openExportOrder(scope.row)">导出PDF</el-button>
                  <el-button type="text" size="small" @click="toPrinted(scope.row)" v-show="fun_dic[1000213]">
                    转已打印
                  </el-button>
                  <el-button type="text" size="small" @click="delData(scope.row)"
                    v-if="Number(scope.row.TC_STATUS) == 2 || Number(scope.row.TC_STATUS) == 3" style="color: #F56C6C">
                    删除
                  </el-button>
                  <el-button type="text" size="small" @click="修改客户(scope.row)"
                    v-if="Number(scope.row.TC_STATUS) == 2 && fun_dic[1000216]">
                    修改客户
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <el-col :span="24" style="text-align: right">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                  :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="供应商客户订单" name="供应商客户订单">
            <el-table :data="supplierCusOrderData" border stripe show-summary style="width: 100%; margin-top: 20px"
              @selection-change="(e) => 供应商客户订单勾选(e)">
              <el-table-column type="selection" width="60"></el-table-column>
              <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="130"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="100"></el-table-column>
              <el-table-column prop="GYS_NAME" label="客户名称" min-width="120"></el-table-column>
              <el-table-column prop="TOTAL_GYS_FEE" label="总价（元）" min-width="90"></el-table-column>
              <el-table-column prop="TOTAL_WEIGHT" label="总重" min-width="90"></el-table-column>
              <el-table-column fixed="right" label="操作" min-width="80">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="supplierCusDetail(scope.row)">
                    查看
                  </el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">
                    导出订单
                  </el-button>
                  <el-button type="text" size="small" @click="outPutDetail(scope.row)">
                    导出详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <el-col :span="24" style="text-align: right">
                <el-pagination @current-change="handleSupplierChange" :current-page.sync="currentSupplierPage"
                  :page-size="supplierPageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-dialog title="转换订单" center :visible.sync="oneButVisible" width="450px">
      <el-form size="small" :model="oneForm" ref="oneForm" label-suffix="：" label-width="auto">
        <el-form-item label="送货日期" :label-width="formLableWidth">
          <el-date-picker v-model="oneForm.SEND_DAY" clearable type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="oneButVisible = false">取 消</el-button>
        <el-button size="small" @click="oneButSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改公司名称 -->
    <el-dialog title="修改公司名称" center :visible.sync="nameFormVisible" width="600px">
      <el-form :model="nameForm" ref="nameForm" label-width="auto" label-suffix="：">
        <el-form-item label="公司名称">
          <el-input v-model="nameForm.companyName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nameFormVisible = false">取 消</el-button>
        <el-button @click="submitPrint" v-if="this.nameForm.companyName === ''" disabled>确 定</el-button>
        <el-button @click="submitPrint" v-else>确 定</el-button>
      </div>
    </el-dialog>
    <!-- 未转换完成的商品 -->
    <el-dialog title="未上架商品" :visible.sync="unSupplierVisible" width="600px" center>
      <el-table :data="tableData" border stripe show-summary style="width: 100%">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="NAME" label="产品名称" min-width="270"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="产品单位" min-width="135"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unSupplierVisible = false">取 消</el-button>
        <el-button @click="unSupplierVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="应急供应商没有采购价格的商品" :visible.sync="unSupplierPurchasePriceVisible" width="800px" center>
      <el-table :data="purchasePriceData" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="SUPPLIER_NAME" label="供应商名称" min-width="150"></el-table-column>
        <el-table-column prop="ORDER_ID" label="订单编码" min-width="135"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="135"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="135"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unSupplierPurchasePriceVisible = false">取 消</el-button>
        <el-button @click="unSupplierPurchasePriceVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入订单 -->
    <el-dialog :visible.sync="exportOrderDialog" title="导入订单" width="400px" center>
      <el-form ref="orderForm" v-model="orderForm" label-width="auto">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.orderForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传xls/xlsx文件，且不超过500kb
          </div>
        </el-upload>
        <p @click="downLoadOrder" style="color: #409eff; margin-top: 20px; cursor: pointer">
          点击下载导入模板
        </p>
        <p style="color: red">您当前使用的产品单位是{{ isUseKG == 1 ? '公斤' : '斤' }}</p>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="exportOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportOrder">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导入订单 -->
    <el-dialog :visible.sync="exportPriceOrderDialog" title="导入订单" width="400px" center>
      <el-form ref="priceOrderForm" v-model="priceOrderForm" label-width="auto">
        <el-upload :data="$uploadParams" class="upload-demo" ref="upload" action="/uploadFile" :on-remove="handleRemove"
          :on-success="handleSuccess" :name="priceOrderForm.orderName" multiple :limit="1" accept=".xls,.xlsx"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传xls/xlsx文件，且不超过500kb
          </div>
        </el-upload>
        <p @click="downPriceOrder" style="color: #409eff; margin-top: 20px; cursor: pointer">
          点击下载导入模板
        </p>
        <p style="color: red">您当前使用的产品单位是{{ isUseKG == 1 ? '公斤' : '斤' }}</p>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="exportPriceOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handlePriceOrder">确认</el-button>
      </div>
    </el-dialog>
    <!-- 不合并商品 -->
    <el-dialog :visible.sync="exportPriceOrderNoGoodsDialog" title="导入订单不合并商品" width="400px" center>
      <el-form ref="priceOrderNoGoodsForm" v-model="priceOrderNoGoodsForm" label-width="auto">
        <el-upload class="upload-demo" ref="upload" action="/uploadFile" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="priceOrderNoGoodsForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <p @click="downPriceOrder" style="color: #409eff; margin-top: 20px; cursor: pointer">
            点击下载导入模板
          </p>
          <div slot="tip" class="el-upload__tip">
            只能上传xls/xlsx文件，且不超过500kb
          </div>
        </el-upload>
        <p style="color: red">导入的表格价格及数量均以公斤为单位</p>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="exportPriceOrderNoGoodsDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handlePriceOrderNoGoods">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导出PDF模态框 -->
    <el-dialog title="导出PDF" center :visible.sync="pdfFormVisible" width="500px">
      <!-- <p style="color: red; font-size: 22px">
        导出完成后订单将从待送订单转至待确认订单
      </p> -->
      <el-form :model="pdfForm" ref="pdfForm" label-suffix="：" label-width="auto">
        <el-form-item label="是否带价格">
          <el-radio-group v-model="priceRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否导出实发数量">
          <el-radio-group v-model="sendCountRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否带实收">
          <el-radio-group v-model="realCountRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单格式">
          <el-radio-group v-model="docType">
            <el-radio :label="1">全联单</el-radio>
            <el-radio :label="0">半联单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否带供应商抬头">
          <el-radio-group v-model="showSupplierName">
            <el-radio :label="1">带供应商抬头</el-radio>
            <el-radio :label="0">不带供应商抬头</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否使用短名称">
          <el-radio-group v-model="USE_SHORT_NAME">
            <el-radio :label="1">使用短名称</el-radio>
            <el-radio :label="0">使用长名称</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfFormVisible = false">取 消</el-button>
        <el-button @click="submitExport">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改日期模态框 -->
    <el-dialog title="修改送货日期" center :visible.sync="DateVisible" width="400px" @close="closeDate">
      <p style="color: red">此功能请在和客户约定好之后进行使用，慎用！</p>
      <el-form v-model="editDateForm" :ref="editDateForm" label-suffix="：" label-width="auto">
        <el-form-item label="选择目标日期">
          <el-date-picker v-model="editDateForm.CHSEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button @click="closeDate">取 消</el-button>
        <el-button @click="submitModifyDate">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 单个订单导出PDF -->
    <el-dialog title="订单打印" center :visible.sync="orderPrintDialog" width="520px" :close-on-click-modal="false">
      <el-form size="small" :model="orderPrintForm" ref="orderPrintForm" label-width="auto" :rules="rules"
        label-suffix="：">
        <el-form-item label="是否带价格" label-width='150px'>
          <el-radio v-model="orderPrintForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="orderPrintForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
        <el-form-item label="是否带送货数量" label-width='150px'>
          <el-radio v-model="orderPrintForm.printCount" label="0">不带送货数量</el-radio>
          <el-radio v-model="orderPrintForm.printCount" label="1">带送货数量</el-radio>
        </el-form-item>
        <el-form-item label="是否实收数量" label-width='150px'>
          <el-radio v-model="orderPrintForm.printReal" label="0">不带实收数量</el-radio>
          <el-radio v-model="orderPrintForm.printReal" label="1">带实收数量</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="printClose">取 消</el-button>
        <el-button size="small" @click="submitOrderPrint('printForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出合并PDF订单 -->
    <el-dialog title="导出合并PDF订单" center :visible.sync="exportOrderFormDialog" width="520px"
      :close-on-click-modal="false">
      <el-form size="small" :model="exportMergeForm" ref="exportMergeForm" :rules="rules" label-suffix="："
        label-width="auto">
        <el-form-item label="送货日期" prop="SEND_DAY">
          <el-date-picker v-model="exportMergeForm.SEND_DAY" type="date" placeholder="选择日期" :clearable="false"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户" prop="COMPANY">
          <el-select v-model="exportMergeForm.COMPANY" filterable placeholder="请选择" clearable
            @change="queryProjectList">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店" prop="PROJECT">
          <el-select v-model="exportMergeForm.PROJECT" filterable placeholder="请选择" clearable>
            <el-option v-for="item in allProjects" :key="item.PROJECT_ID" :label="item.AB_NAME"
              :value="item.PROJECT_ID" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否打印价格">
          <el-radio v-model="exportMergeForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="exportMergeForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
        <el-form-item label="是否打印送货数量">
          <el-radio v-model="exportMergeForm.printCount" label="0">不带送货数量</el-radio>
          <el-radio v-model="exportMergeForm.printCount" label="1">带送货数量</el-radio>
        </el-form-item>
        <el-form-item label="是否实收数量">
          <el-radio v-model="exportMergeForm.printReal" label="0">不带实收数量</el-radio>
          <el-radio v-model="exportMergeForm.printReal" label="1">带实收数量</el-radio>
        </el-form-item>
        <el-form-item label="是否按品类打印送货单">
          <el-radio v-model="exportMergeForm.CATEGORY_PAGE_FLAG" label="0">否</el-radio>
          <el-radio v-model="exportMergeForm.CATEGORY_PAGE_FLAG" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportOrderFormDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitExportOrder('exportMergeForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 沛锦导入高后订单 -->
    <el-dialog :visible.sync="importGHOrderDialog" title="导入订单" width="400px" center>
      <el-form label-width="auto">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess" name="tmp" :limit="1"
          accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downloadGHOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
        <p style="color: red">您当前使用的产品单位是{{ isUseKG == 1 ? '公斤' : '斤' }}</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importGHOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleGHOrder">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="修改客户模态框" title="修改客户" width="500px" center>
      <el-form size="medium" :model="修改客户表单" ref="修改客户表单" label-width="auto" label-suffix="：">
        <el-form-item label="客户" label-width='120px'>
          <el-select @change="(e) => { 修改客户拉取项目点(e) }" filterable v-model="修改客户表单.TC_ID" placeholder="请选择客户">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点" label-width='120px'>
          <el-select @change="(e) => { 修改项目点拉取档口(e) }" filterable v-model="修改客户表单.PROJECT_ID" placeholder="请选择项目点">
            <el-option v-for="item in 修改客户用项目点列表" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口" label-width='120px'>
          <el-select filterable v-model="修改客户表单.DK_ID" placeholder="请选择档口">
            <el-option v-for="item in 修改客户用档口列表" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改客户模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改客户()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  newOrderFun, getHaveSupplyRelationshipProjectList, exportOrderFun, exportTotalOrderFun, setOrderFun, transferSellFun, exportCheckFun,
  exportSellOrder, exportPriceOrder, exportPdfOrder, selectTCFun, _conversionConfirmed,
  supplierCusNewOrder, exportConfirmOrderFun, orderPrintFunc, toPrintedFun, batchExportFun, getTCProjectFun, allOrderExportFun,
} from 'api/sellOrder';

import { supplierCusFun } from 'api/customerManage';
import { getActionFun } from 'api/login';
import date from '@/assets/common/date';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';
import util from '@/assets/common/util';

export default {
  data () {
    return {
      PAGE_ID: '10002', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        1000201: 0,
        1000202: 0,
        1000203: 0,
        1000204: 0,
        1000205: 0,
        1000206: 0,
        1000207: 0,
        1000208: 0,
        1000209: 0,
        1000210: 0,
        1000211: 0,
        1000212: 0,
        1000213: 0,
        1000214: 0,
        1000215: 0,
        1000216: 0,
        1000217: 0,
      },
      团餐客户一键转待确认勾选列表: [],
      团餐客户订单勾选列表: [],
      tmpOrderId: [],
      initLoad: false,
      exportTatolDialog: false,
      customers: [],
      客户类型: '团餐客户订单',
      oneForm: {
        oneCustomer: '',
        SEND_DAY: date(new Date(), '%F'),
      },
      oneCustomers: [],
      oneButVisible: false,
      allProjectsCopy: [],
      points: [
        {
          PROJECT_ID: '',
          PROJECT_NAME: '',
        },
      ],
      dkList: [],
      供应商客户一键转待确认列表: [],
      团餐客户配送类型列表: this.$util.团餐客户配送类型列表,
      newOrderListData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      exportForm: {
        DAY_INTERVAL: [],
      },
      formLableWidth: '120px',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      index: 0,
      nameFormVisible: false,
      nameForm: {
        companyName: '',
      },
      unSupplierVisible: false,
      unSupplierPurchasePriceVisible: false,
      printData: {},
      tableData: [],
      purchasePriceData: [],
      searchForm: {
        SUPPLIER: '', DAY_INTERVAL: [], TC_COMPANY: '', PROJECT: [], dkName: '', SEND_DAY: '', STATUS: '', PRODUCT_NAME: '',
      },
      statusList: [
        {
          value: '0',
          label: '未转',
        },
        {
          value: '1',
          label: '已转',
        },
      ],
      exportOrderDialog: false,
      orderForm: {
        orderName: 'tmp',
      },
      fileList: [],
      file_name: '',
      exportFlag: 0,
      priceOrderForm: {
        orderName: 'tmp',
      },
      priceOrderNoGoodsForm: {
        orderName: 'tmp',
      },
      exportPriceOrderNoGoodsDialog: false,
      exportPriceOrderDialog: false,
      exportPriceFlag: 0,
      pdfFormVisible: false,
      pdfForm: {},
      priceRadio: 1,
      sendCountRadio: 1,
      USE_SHORT_NAME: 0,
      realCountRadio: 0,
      docType: 1,
      showSupplierName: 1,
      companys: [],
      pageTitle: '待送订单列表',
      DateVisible: false,
      ORDER_ID_DATE: 0,
      CHSEND_DAY: '',
      editDateForm: {},
      // 供应商客户
      supplierCusOrderData: [],
      currentSupplierPage: 1,
      supplierPageSize: 10,
      supplierList: [],
      currentFlag: 0,
      transferFlag: 0,
      orderPrintDialog: false,
      orderPrintForm: {
        printPrice: '0',
        printCount: '0',
        printReal: '0',
      },
      rules: {
        COMPANY: [
          { required: true, message: '请选择客户', trigger: 'blur' },
        ],
        SEND_DAY: [
          { required: true, message: '请选择送货日期', trigger: 'change' },
        ],
      },
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      isUseKG: sessionStorage.getItem('IS_USE_KG'),
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      exportOrderFormDialog: false,
      exportMergeForm: {
        printPrice: '0',
        printCount: '0',
        printReal: '0',
        CATEGORY_PAGE_FLAG: '0',
        PROJECT: '',
      },
      allProjects: [],
      importGHOrderDialog: false,
      修改客户模态框: false,
      修改客户表单: {},
      修改客户用项目点列表: [],
      修改客户用档口列表: [],
    };
  },
  computed: {
    // 上一次的搜索结果和条件
    销售订单待送订单存储数据 () {
      return this.$store.state.销售订单待送订单存储数据;
    },
    是团餐客户列表 () {
      return this.客户类型 == '团餐客户订单';
    },
    是供应商客户列表 () {
      return this.客户类型 == '供应商客户订单';
    },
  },
  created () {
    this.queryBeforeFun();

    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.supplierPageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.销售订单待送订单存储数据) {
      this.客户类型 = this.销售订单待送订单存储数据.客户类型;
      this.searchForm = this.销售订单待送订单存储数据.CONDITION;
      this.currentPage = this.销售订单待送订单存储数据.CURRENT_PAGE;
      this.querydkList();
    } else {
      this.currentPage = 1;
    }
    if (this.客户类型 == '团餐客户订单') {
      // this.currentPage = 1;
      this.queryNewOrderListData(); // 获取团餐客户订单列表
    } else {
      // this.currentSupplierPage = 1;
      this.querySupplierCusOrder();// 获取供应商订单列表
    }
    // 获取供应商客户列表
    this.querySupplierList();
    // 获取团餐客户列表
    this.queryCustomer();
    // 获取项目点列表
    this.loadData();
  },
  methods: {
    确认修改客户 () {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 103,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.修改客户表单.ORDER_ID,
        TC_ID: this.修改客户表单.TC_ID,
        PROJECT_ID: this.修改客户表单.PROJECT_ID,
        STALL_ID: this.修改客户表单.DK_ID,
      };
      http.post(params).then((res) => {
        this.queryNewOrderListData();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.修改客户表单 = {};
        this.修改客户模态框 = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改项目点拉取档口 (e) {
      if (!this.修改客户表单.PROJECT_ID) {
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: e,
      };
      http.post(params).then((result) => {
        this.修改客户用档口列表 = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    修改客户拉取项目点 (e) {
      if (!this.修改客户表单.TC_ID) {
        return false;
      }
      this.修改客户表单.PROJECT_ID = '';
      const params = {
        TC_ID: e,
      };
      getHaveSupplyRelationshipProjectList(params).then((result) => {
        if (result[0]) {
          this.修改客户用项目点列表 = result;
        } else {
          this.修改客户用项目点列表 = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改客户 (row) {
      this.修改客户模态框 = true;
      this.修改客户表单.ORDER_ID = row.ID;
    },
    // 导出合并PDF提交
    submitExportOrder () {
      this.$refs.exportMergeForm.validate((valid) => {
        if (valid) {
          const params = {
            SEND_DAY: this.exportMergeForm.SEND_DAY,
            TC_ID: this.exportMergeForm.COMPANY,
            PRICE_FLAG: Number(this.exportMergeForm.printPrice),
            ORDER_FLAG: 3,
            SEND_COUNT_FLAG: Number(this.exportMergeForm.printCount),
            iRCOUNTFlag: Number(this.exportMergeForm.printReal),
            CATEGORY_PAGE_FLAG: Number(this.exportMergeForm.CATEGORY_PAGE_FLAG),
          };
          if (this.exportMergeForm.PROJECT !== '') {
            params.PROJECT_ID = this.exportMergeForm.PROJECT;
          }
          if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
            params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
          }
          batchExportFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportOrderFormDialog = false;
            this.$nextTick(() => {
              this.$refs.exportMergeForm.resetFields();
            });
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        } else {
          return false;
        }
      });
    },
    // 导出合并PDF订单
    exportMergeOrder () {
      this.exportOrderFormDialog = true;
    },
    queryProjectList (e) {
      const paramsProject = {
        TC_ID: e,
      };
      getTCProjectFun(paramsProject).then((result) => {
        if (result[0]) {
          this.allProjects = result;
        } else {
          this.allProjects = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    conversionConfirmed () {
      if (this.团餐客户一键转待确认勾选列表.length !== 0) {
        this.tmpOrderId = [];
        this.团餐客户一键转待确认勾选列表.forEach((item, index) => {
          this.tmpOrderId.push(item.ORDER_ID);
        });
        this.submitArr = this.tmpOrderId.filter((ele, index, self) => self.indexOf(ele) === index);
        const params = {
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          ORDERS: this.submitArr,
        };
        _conversionConfirmed(params).then((result) => {
          this.queryNewOrderListData();
          this.queryCustomer();
          this.loadData();
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择订单', type: 'warning' });
      }
    },
    团餐客户订单勾选 (val) {
      this.团餐客户一键转待确认勾选列表 = val.map((item) => ({ ORDER_ID: item.ID }));
      this.团餐客户订单勾选列表 = val.map((item) => item.ID); // 团餐客户 导出订单用的
    },
    供应商客户订单勾选 (e) {
      this.供应商客户一键转待确认列表 = e.map((item) => item.ORDER_ID);
    },
    // 供应商转换待确认
    supplierConversionConfirmed () {
      const params = {
        SERVICE_ID: '10176',
        OTYPE: 80,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_IDS: this.供应商客户一键转待确认列表,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '转换成功', type: 'success' });
        this.querySupplierCusOrder();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryForm (TC_ID) {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 0,
        TC_ID,
      };
      http.post(params).then((result) => {
        if (result[0].USE_PRINT_TEMPLATE == 1) {
          this.$router.push({ name: 'sellOrderCustomPrintDetail' });
        } else {
          this.$router.push({ name: 'sellOrderPrint' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------一键转化/打印
    oneButton (row) {
      this.printData = row;
      let flag = true;
      if (row.TC_STATUS === 1) {
        const sendDate = new Date(row.SEND_DAY);
        const currentDate = new Date();
        const diffMonth = currentDate.getMonth() - sendDate.getMonth();
        if (sendDate.getYear() < currentDate.getYear()
          || (sendDate.getYear() == currentDate.getYear() && sendDate.getMonth() < currentDate.getMonth() && new Date().getDate() > 10)
          || (sendDate.getYear() == currentDate.getYear() && sendDate.getMonth() < currentDate.getMonth() && new Date().getDate() < 10 && diffMonth > 1)) {
          this.$message.show({ text: '根据公司要求，跨月订单无法打印，请联系项目点处理', type: 'warning' });
          flag = false;
        }
      }
      if (flag) {
        if (row.SUPPLIER_STATUS === 0) {
          this.transferFlag = 0;
          this.oneButVisible = true;
          this.oneOrderId = row.ID;
          this.oneForm.SEND_DAY = row.SEND_DAY;
        } else {
          this.$store.dispatch('backupFilterMemory');
          this.queryForm(row.TC_ID);
          sessionStorage.setItem('countFlag', 0);
          sessionStorage.setItem('orderId', row.ID);
          sessionStorage.setItem('isShortDocFlag', 0);
          sessionStorage.setItem('printRealFlag', 0);
          sessionStorage.setItem('TBSsearchForm', JSON.stringify(this.searchForm));
          sessionStorage.setItem('TEM_TCID', row.TC_ID);
        }
      }
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (
          index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 6 || index === 9 || index === 10 || index === 11 || index === 12) {
          return;
        }
        const values = data.map((item) => Number(item[column.property])); // 总价列的数组
        if (!values.every((value) => Number.isNaN(value))) {
          // 判断当前列有无NaN  ，有则直接这一列合计为 '--'
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); // 防止是字符串累加
            if (!Number.isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // -------------------------------------选择客户
    queryCustomer () {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.companys = [...new Set(result[0].company.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------一键转换确认
    oneButSubmit () {
      // 关账限制
      if (this.$util.isOrderClosed(this.oneForm.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法转换', type: 'warning' });
        return false;
      }
      this.transferOrderId = [];
      this.团餐客户一键转待确认勾选列表.forEach((item, index) => {
        this.transferOrderId.push(item.ORDER_ID);
      });
      this.submitTransferArr = this.transferOrderId.filter((ele, index, self) => self.indexOf(ele) === index);
      const oneOrderArr = [];
      oneOrderArr.push(this.oneOrderId);
      const params = {
        SEND_DAY: date(this.oneForm.SEND_DAY, '%F'),
        PRICE_MODE: this.userPriceType,
      };
      if (this.transferFlag == 1) {
        params.ORDER_ID = this.submitTransferArr;
      } else {
        params.ORDER_ID = oneOrderArr;
      }
      transferSellFun(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryNewOrderListData();
        } else if (res[0].FLAG == 1) {
          this.$message.show({ text: '部分商品没有供应商供应', type: 'warning' });
          this.tableData = res[0].PRODUCTS;
          this.unSupplierVisible = true;
        } else if (res[0].FLAG == 2) {
          this.$message.show({ text: '部分商品应急供应商没有采购价格', type: 'warning' });
          this.purchasePriceData = res[0].PRODUCT;
          this.unSupplierPurchasePriceVisible = true;
        }
        this.oneButVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    transferShop () {
      if (this.团餐客户一键转待确认勾选列表.length !== 0) {
        this.oneButVisible = true;
        this.transferFlag = 1;
      } else {
        this.$message.show({ text: '请选择订单', type: 'warning' });
      }
    },
    detail (row) {
      sessionStorage.setItem('sendDay', row.SEND_DAY);
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('projectid', row.PROJECT_ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      sessionStorage.setItem('ORDER_TC_ID', row.TC_ID);
      sessionStorage.setItem('NEED_TCNAME', row.TC_NAME);
      sessionStorage.setItem('TBSsearchForm', JSON.stringify(this.searchForm));
      this.$router.push({ path: '/newOrderDetail/detail' });
    },
    delData (row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10004',
            OTYPE: 8,
            ORDER_ID: Number(row.ID),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          };
          if (row.TC_STATUS != 2) {
            this.$message.show({ text: '只能删除自录客户订单', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryNewOrderListData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
        }
      }
    },
    orderContract (row) {
      this.$router.push({ name: 'orderContract', params: { id: row.ID } });
      sessionStorage.setItem('pageTitle', this.pageTitle);
      this.$store.dispatch('backupFilterMemory');
    },
    // -----------------------获取新订单列表
    queryNewOrderListData () {
      if (this.searchForm.ORDER_ID && !validation.订单ID验证(this.searchForm.ORDER_ID)) {
        this.$message.show({ text: '订单ID只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_COMPANY && this.searchForm.TC_COMPANY.length != 0) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        params.PROJECTS_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (this.searchForm.dkName) {
        params.DK_ID = this.searchForm.dkName;
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.STATUS) {
        params.SUPPLIER_STATUS = this.searchForm.STATUS;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.ORDER_LIST_COMMENT) {
        params.ORDER_LIST_COMMENT = this.searchForm.ORDER_LIST_COMMENT;
      }
      if (this.searchForm.DETAIL_TYPE && this.searchForm.DETAIL_TYPE.length) {
        params.DETAIL_TYPE = this.searchForm.DETAIL_TYPE;
      }
      this.initLoad = true;
      newOrderFun(params).then((result) => {
        if (result.length != 0) {
          this.newOrderListData = result.length > 0 ? result[0].list : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
        } else {
          this.newOrderListData = [];
          this.totalCount = 0;
        }
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('设置销售订单待送订单存储数据', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
          客户类型: this.客户类型,
          TOTAL_COUNT: this.totalCount,
        });
        this.initLoad = false;
      }).catch((error) => {
        this.initLoad = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------导出一条订单
    output (row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const orderParams = {
            PRICE_MODE: this.userPriceType,
          };
          if (this.是供应商客户列表) {
            orderParams.IS_SUPPLIER_CLIENT = 1;
            orderParams.ORDER_ID = row.ORDER_ID;
          } else {
            orderParams.ORDER_ID = row.ID;
          }
          // this.outLoad = true
          exportOrderFun(orderParams).then((result) => {
            // this.outLoad = false
            this.$message.show({ text: '导出成功', type: 'success' });
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
        }
      }
    },
    openExport () {
      this.exportDialogVisible = true;
    },
    // ----------------------------导出日期范围内订单
    团餐导出订单 () {
      if (this.团餐客户订单勾选列表 && this.团餐客户订单勾选列表.length !== 0) {
        this.submitExportChecked();
      } else {
        if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
          this.submitExportDate();
        } else {
          this.$message.show({ text: '请选择起始日期', type: 'warning' });
          return false;
        }
      }
    },
    供应商导出订单 () {
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        this.submitExportDate();
      } else {
        this.$message.show({ text: '请选择起始日期', type: 'warning' });
        return false;
      }
    },
    // 全部信息导出订单（含产品明细等完整信息）
    exportAllInfoOrder () {
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        const params = {
          START_DAY: this.searchForm.DAY_INTERVAL[0],
          END_DAY: this.searchForm.DAY_INTERVAL[1],
          STATUS: [1, 2],
        };
        if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
          params.PROJECT_ID = this.searchForm.PROJECT;
        }
        if (this.是供应商客户列表) {
          params.IS_SUPPLIER_CLIENT = 1;
          params.THIRD_INFO = 1;
          if (this.searchForm.SUPPLIER) {
            params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
          }
        }
        if (this.是团餐客户列表) {
          if (this.searchForm.TC_COMPANY) params.TC_ID = this.searchForm.TC_COMPANY;
        }
        if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
          params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
        }
        if (this.searchForm.DETAIL_TYPE && this.searchForm.DETAIL_TYPE.length) params.DETAIL_TYPE = this.searchForm.DETAIL_TYPE;
        allOrderExportFun(params).then((result) => {
          if (result[0]) {
            if (result[0].TASK_CREATED_SUCCESSFULLY) {
              this.$util.getUnreadInformation(this);
              this.$confirm(this.$util.appointmentMessage, '温馨提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
              }).then(() => {
                this.$router.push({ name: 'appointmentHandling' });
              }).catch(() => {
                this.$message.show({ type: 'info', text: '取消操作' });
              });
            }
            if (result[0].FILE_PATH) window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
          } else this.$message.show({ text: '无相关信息', type: 'warning' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
    },
    submitExportDate () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const exportTotalParams = {
            START_DATE: this.searchForm.DAY_INTERVAL[0],
            END_DATE: this.searchForm.DAY_INTERVAL[1],
          };
          if (this.是供应商客户列表) {
            // 供应商客户 导出订单
            exportTotalParams.IS_SUPPLIER_CLIENT = 1;
            exportTotalParams.STATUS = 1;
            exportTotalParams.THIRD_INFO = 1;
            if (this.searchForm.SUPPLIER) {
              exportTotalParams.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
            }
            exportConfirmOrderFun(exportTotalParams).then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
          } else {
            // 团餐客户 导出订单
            if (this.searchForm.PROJECT.length !== 0) {
              exportTotalParams.PROJECTS_ID = this.searchForm.PROJECT;
            }
            if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
              exportTotalParams.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
            }
            exportTotalOrderFun(exportTotalParams).then((result) => {
              if (result[0] && result[0].FILE_PATH) {
                window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
                document.body.style.cursor = 'default';
              } else {
                this.$message.show({ text: '无相关数据', type: 'warning' });
              }
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
          }
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    submitExportChecked () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10009',
            OTYPE: 46,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            ORDER_LIST: this.团餐客户订单勾选列表,
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportTatolDialog = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
        }
      }
    },
    close () {
      this.exportTatolDialog = false;
    },
    // ---------------------------------------设置是否为补单
    setAddedOrderFlag (row, flag) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ID,
            FLAG: flag,
          };
          setOrderFun(params).then((result) => {
            this.$message.show({ text: '更新成功', type: 'success' });
            this.queryNewOrderListData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
        }
      }
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryNewOrderListData();
    },
    // ----------------------------------------点击筛选按钮触发
    handleSearch () {
      if (this.是团餐客户列表) {
        this.currentPage = 1;
        // 获取团餐客户订单列表
        this.queryNewOrderListData();
      } else if (this.是供应商客户列表) {
        this.currentSupplierPage = 1;
        // 获取供应商订单列表
        this.querySupplierCusOrder();
      }
    },
    // ---------------------------------------获取项目点信息列表
    loadData () {
      getHaveSupplyRelationshipProjectList().then((result) => {
        this.points = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------------------下拉框获取档口名称
    querydkList () {
      if (this.searchForm.PROJECT.length === 0) {
        this.dkList = [];
        this.searchForm.dkName = '';
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },

    submitPrint () {
      this.$router.push({ name: 'sellOrderCustomPrintDetail' });
      sessionStorage.setItem('countFlag', 0);
      sessionStorage.setItem('printRealFlag', 0);
      sessionStorage.setItem('orderId', this.nameForm.ORDER_ID);
      sessionStorage.setItem('supplierName', this.nameForm.companyName);
      this.$store.dispatch('backupFilterMemory');
      sessionStorage.setItem('TEM_TCID', this.nameForm.TC_ID);
    },
    exportCheck (row) {
      const params = {
        ORDER_ID: row.ID,
      };
      if (this.是供应商客户列表) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      exportCheckFun(params).then((result) => {
        this.$message.show({ text: '导出成功', type: 'success' });
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 选取客户 拉取对应项目点
    queryPROJECT () {
      if (!this.searchForm.TC_COMPANY) {
        this.searchForm.PROJECT = [];
        this.searchForm.dkName = '';
        return false;
      }
      this.searchForm.PROJECT = [];
      const paramsProject = {
        TC_ID: this.searchForm.TC_COMPANY,
      };
      getHaveSupplyRelationshipProjectList(paramsProject).then((result) => {
        if (result[0]) {
          this.points = result;
        } else {
          this.points = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导入订单
    exportEnterOrder (e) {
      this.exportOrderDialog = true;
      this.exportFlag = e;
    },
    handleSuccess (response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove (file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    handleExportOrder () {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
          STATUS: 1,
          PRICE_MODE: this.userPriceType,
        };
        if (this.exportFlag == 1) {
          params.USE_TC_PRODUCT_CODE = 1;
        }
        exportSellOrder(params).then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.exportOrderDialog = false;
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    downLoadOrder () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/smpsaleordertemp.xls';
    },
    exportPriceOrder (flag) {
      this.exportPriceOrderDialog = true;
      this.exportPriceFlag = flag;
    },
    exportPriceOrderNoGoods () {
      this.exportPriceOrderNoGoodsDialog = true;
    },

    downPriceOrder () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/smpsaleorderwithpricetemp.xls';
    },
    handlePriceOrder () {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
          STATUS: 1,
        };
        if (this.exportPriceFlag == 1) {
          params.USE_TC_PRODUCT_CODE = 1;
        }
        exportPriceOrder(params).then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.exportPriceOrderDialog = false;
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    handlePriceOrderNoGoods () {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
          SERVICE_ID: '10004',
          OTYPE: 31,
          MERGE_ORDER_DETAIL: 0,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          STATUS: 1,
        };
        http.post(params).then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.exportPriceOrderNoGoodsDialog = false;
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    openExportPDF () {
      // 是团餐客户列表 导出PDF
      if (!(this.团餐客户订单勾选列表 && this.团餐客户订单勾选列表[0]) && !this.searchForm.SEND_DAY) {
        this.$message.show({ text: '请选择送货日期或对订单进行勾选', type: 'warning' });
      } else if ((this.团餐客户订单勾选列表 && this.团餐客户订单勾选列表[0]) || this.searchForm.SEND_DAY) {
        this.pdfFormVisible = true;
      }
    },
    submitExport () {
      if (this.团餐客户订单勾选列表 && this.团餐客户订单勾选列表[0]) {
        this.submitExportPdfChecked();
      } else {
        this.submitExportPdf();
      }
    },
    submitExportPdf () {
      const params = {
        PRICE_FLAG: this.priceRadio,
        SEND_COUNT_FLAG: this.sendCountRadio,
        iRCOUNTFlag: this.realCountRadio,
        HALF_PAGE_FLAG: this.docType,
        SHOW_SUPPLIER_NAME: this.showSupplierName,
        STATUS: 1,
        USE_SHORT_NAME: this.USE_SHORT_NAME,
      };
      params.START_DAY = this.searchForm.SEND_DAY;
      params.END_DAY = this.searchForm.SEND_DAY;
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      exportPdfOrder(params).then((result) => {
        this.$message.show({ text: '导出PDF成功', type: 'success' });
        this.pdfFormVisible = false;
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitExportPdfChecked () {
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 26,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_LIST: this.团餐客户订单勾选列表,
        PRICE_FLAG: this.priceRadio,
        SEND_COUNT_FLAG: this.sendCountRadio,
        iRCOUNTFlag: this.realCountRadio,
        HALF_PAGE_FLAG: this.docType,
        SHOW_SUPPLIER_NAME: this.showSupplierName,
        USE_SHORT_NAME: this.USE_SHORT_NAME,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '导出PDF成功', type: 'success' });
        this.pdfFormVisible = false;
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 打开修改日期模态框
    openDateDia (row) {
      this.ORDER_ID_DATE = row.ID;
      this.DateVisible = true;
    },
    // 关闭修改日期模态框
    closeDate () {
      this.DateVisible = false;
      this.editDateForm = {};
    },
    // 修改日期
    submitModifyDate () {
      // 关账限制
      if (this.$util.isOrderClosed(this.editDateForm.CHSEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法修改为此日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 45,
        ORDER_ID: Number(this.ORDER_ID_DATE),
      };
      if (this.editDateForm.CHSEND_DAY) {
        params.CHSEND_DAY = this.editDateForm.CHSEND_DAY;
      } else {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.queryNewOrderListData();
        this.DateVisible = false;
        this.editDateForm = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleTabClick (tab, event) {
      this.供应商客户一键转待确认列表 = [];
      this.团餐客户订单勾选列表 = [];
      this.团餐客户一键转待确认勾选列表 = [];
      if (this.是团餐客户列表) {
        this.currentPage = 1;
        // 获取团餐客户订单列表
        this.queryNewOrderListData();
      } else if (this.是供应商客户列表) {
        this.currentSupplierPage = 1;
        // 获取供应商订单列表
        this.querySupplierCusOrder();
      }
    },
    // 拉取供应商客户订单
    querySupplierCusOrder () {
      if (this.searchForm.ORDER_ID && !validation.订单ID验证(this.searchForm.ORDER_ID)) {
        this.$message.show({ text: '订单ID只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        PAGESIZE: this.supplierPageSize,
        PAGEINDEX: this.currentSupplierPage - 1,
        IS_SUPPLIER_CLIENT: 1,
      };
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      supplierCusNewOrder(params).then((result) => {
        if (result.length != 0) {
          this.supplierCusOrderData = result.length > 0 ? result[0].list : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
        } else {
          this.supplierCusOrderData = [];
          this.totalCount = 0;
        }
        this.$store.dispatch('设置销售订单待送订单存储数据', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
          客户类型: this.客户类型,
          TOTAL_COUNT: this.totalCount,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSupplierChange (e) {
      this.currentSupplierPage = e;
      this.querySupplierCusOrder();
    },
    // 团餐查看
    supplierCusDetail (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      if (this.客户类型 == '供应商客户订单') {
        sessionStorage.setItem('currentOrderFlag', 1);
      } else {
        sessionStorage.setItem('currentOrderFlag', 0);
      }
      this.$store.dispatch('backupFilterMemory');
      sessionStorage.setItem('TEM_GYSSCID', row.GYS_ID);
      sessionStorage.setItem('TEM_ISSUPPLIER', 0);
      this.$router.push({ path: '/supplierCusNewOrderDetail/detail' });
    },
    // 获取客户列表
    querySupplierList () {
      const params = {};
      supplierCusFun(params).then((res) => {
        if (res.length !== 0) {
          this.supplierList = res[0].list;
        } else {
          this.supplierList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 导出详情
    outPutDetail (row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '15064',
            OTYPE: 2,
            PURCHASE_ORDER_ID: row.ORDER_ID,
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
        }
      }
    },
    openExportOrder (row) {
      this.orderPrintDialog = true;
      this.orderPrintForm.ID = row.ID;
    },
    printClose (formName) {
      this.$nextTick(() => {
        this.$refs.printForm.resetFields();
      });
      this.printFormDialog = false;
      this.orderPrintDialog = false;
    },
    submitOrderPrint () {
      const params = {
        PRICE_FLAG: Number(this.orderPrintForm.printPrice),
        ORDER_ID: this.orderPrintForm.ID,
        SEND_COUNT_FLAG: Number(this.orderPrintForm.printCount),
        iRCOUNTFlag: Number(this.orderPrintForm.printReal),
      };
      orderPrintFunc(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.orderPrintDialog = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 单个转换已打印
    toPrinted (row) {
      const params = {
        ORDER_ID: row.ID,
      };
      toPrintedFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryNewOrderListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    importGHOrder () {
      this.importGHOrderDialog = true;
    },
    批量删除 () {
      if (this.团餐客户一键转待确认勾选列表.length == 0) {
        this.$message.show({ text: '请勾选需要删除的订单', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 8,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.团餐客户一键转待确认勾选列表.map(({ ORDER_ID }) => ORDER_ID),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryNewOrderListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    downloadGHOrder () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/高后订单导入模板表.xlsx';
    },
    handleGHOrder () {
      if (this.file_name) {
        const params = {
          SERVICE_ID: '10004',
          OTYPE: 52,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          FILE_NAME: this.file_name,
          STATUS: 1,
          USE_TC_PRODUCT_CODE: 1,
        };
        http.post(params).then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.importGHOrderDialog = false;
            this.queryTable();
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
  },
};
</script>
<style scoped>
/* 作用于本页面所有 dialog 内的表单控件：el-dialog 渲染在本组件内，
   vue-loader 13 只支持单个 >>>，编译后为 .el-dialog__wrapper[data-v-xxx] .el-dialog ...，
   scoped 保证不影响其他页面，不新增类 */
.el-dialog__wrapper>>>.el-select,
.el-dialog__wrapper>>>.el-autocomplete,
.el-dialog__wrapper>>>.el-input,
.el-dialog__wrapper>>>.el-date-editor {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/NewOrderList.vue